import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoChevronBack, IoEllipsisVertical } from 'react-icons/io5';

const CommonLayout = ({ title, showBackButton = true, onBack, showMoreButton = false, onMore, children }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* 헤더바 */}
      <div className="fixed top-0 left-0 right-0 z-20 bg-white flex items-center justify-between px-4 py-3 border-b border-gray-200" style={{ minHeight: '65px' }}>
        {showBackButton ? (
          <button onClick={handleBack} className="p-2">
            <IoChevronBack size={24} className="text-gray-700" />
          </button>
        ) : (
          <div className="w-10 h-full" />
        )}
        <h1 className="text-lg font-semibold text-gray-800">{title}</h1>
        {showMoreButton ? (
          <button onClick={onMore} className="p-2">
            <IoEllipsisVertical size={24} className="text-gray-700" />
          </button>
        ) : (
          <div className="w-10 h-full" />
        )}
      </div>

      {/* 본문 */}
      <div className="pt-[65px]">
        {children}
      </div>
    </div>
  );
};

export default CommonLayout;
